var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettouReportCommon',{attrs:{"createReportComponent":_vm.createReportComponent,"startWorkComponent":_vm.startWorkComponent,"saveWorkSituationComponent":_vm.saveWorkSituationComponent,"detailApis":_vm.detailApis}})}
var staticRenderFns = []

export { render, staticRenderFns }